import routes from "routes";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import Card from "@mui/material/Card";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Author page sections

import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

import React, { useState } from "react";
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  IconButton,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

import MKTypography from "components/MKTypography";
import { Helmet } from "react-helmet-async";

export default function ApoyoEscolarPage() {
  const [afiliado, setAfiliado] = useState({
    nombre: "",
    apellido: "",
    numeroAfiliado: "",
    lugarTrabajo: "",
    fechaAfiliacion: "",
  });

  // ====== HIJOS (DINÁMICO) ======
  const [hijos, setHijos] = useState([
    {
      nombre: "",
      apellido: "",
      escuela: "",
      edad: "",
      clases: false,
      utiles: false,
      notebook: false,
    },
  ]);

  // ====== DECLARACIÓN JURADA ======
  const [ddjj, setDdjj] = useState(false);

  // ====== HANDLERS AFILIADO ======
  const handleAfiliadoChange = (e) => {
    const { name, value } = e.target;
    setAfiliado({ ...afiliado, [name]: value });
  };

  // ====== HANDLERS HIJOS ======
  const handleHijoChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const nuevos = [...hijos];
    nuevos[index][name] = type === "checkbox" ? checked : value;
    setHijos(nuevos);
  };

  const agregarHijo = () => {
    setHijos([
      ...hijos,
      {
        nombre: "",
        apellido: "",
        escuela: "",
        edad: "",
        clases: false,
        utiles: false,
        notebook: false,
      },
    ]);
  };

  const eliminarHijo = (index) => {
    const nuevos = hijos.filter((_, i) => i !== index);
    setHijos(nuevos);
  };

  // ====== ENVÍO ======
  const handleSubmit = () => {
    const data = {
      afiliado,
      hijos,
      ddjj,
    };
    console.log("Formulario enviado:", data);
  };
  return (
    <>
      <Helmet>
        <title>Apoyo Escolar 2026 | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Solicitá útiles escolares, clases de apoyo y notebooks para tus hijos. Formulario exclusivo para afiliados al Sindicato de Panaderos de San Juan - Ciclo Lectivo 2026."
        />

        <meta
          name="keywords"
          content="apoyo escolar panaderos, útiles escolares gratis san juan, clases de apoyo sindicato, beneficios hijos panaderos, ayuda escolar 2026"
        />

        {/* Open Graph para redes sociales */}
        <meta property="og:title" content="Apoyo Escolar 2026 - Sindicato de Panaderos" />
        <meta
          property="og:description"
          content="Ya está abierta la solicitud de beneficios escolares para hijos de afiliados. ¡Completá el formulario online!"
        />
        <meta
          property="og:image"
          content="https://www.mundiario.com/media/mundiario/images/2019/01/30/2019013017451762854.jpg"
        />
        <meta property="og:type" content="website" />

        <link rel="canonical" href="https://www.sindicatopanaderossanjuan.com.ar/apoyo-escolar" />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://www.campinglacdusalagou.fr/wp-content/uploads/2025/06/activite-en-famille-au-camping-Montpellier.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={2}>
            <Container>
              <Grid container item xs={12} lg={6}>
                <MKTypography variant="h3" mb={6}>
                  Solicitud apoyo escolar 2026
                </MKTypography>
              </Grid>
              <Grid container spacing={3}>
                <Box sx={{ maxWidth: 900, mx: "auto", p: 3 }}>
                  {/* TÍTULO */}
                  <Typography variant="h4" fontWeight="bold" mb={1}>
                    Solicitud de Apoyo Escolar 2026
                  </Typography>
                  <Box sx={{ width: "100%", height: "3px", backgroundColor: "#2196f3", mb: 4 }} />

                  {/* ================= DATOS AFILIADO ================= */}
                  <Paper sx={{ p: 3, mb: 4 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      Datos del Afiliado
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Nombre"
                          name="nombre"
                          value={afiliado.nombre}
                          onChange={handleAfiliadoChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Apellido"
                          name="apellido"
                          value={afiliado.apellido}
                          onChange={handleAfiliadoChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Número de afiliado"
                          name="numeroAfiliado"
                          value={afiliado.numeroAfiliado}
                          onChange={handleAfiliadoChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Lugar de trabajo"
                          name="lugarTrabajo"
                          value={afiliado.lugarTrabajo}
                          onChange={handleAfiliadoChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Fecha de afiliación"
                          name="fechaAfiliacion"
                          InputLabelProps={{ shrink: true }}
                          value={afiliado.fechaAfiliacion}
                          onChange={handleAfiliadoChange}
                        />
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* ================= HIJOS ================= */}
                  {hijos.map((hijo, i) => (
                    <Paper key={i} sx={{ p: 3, mb: 3 }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight="bold">
                          Hijo/a {i + 1}
                        </Typography>
                        {hijos.length > 1 && (
                          <IconButton color="error" onClick={() => eliminarHijo(i)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Box>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Nombre"
                            name="nombre"
                            value={hijo.nombre}
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Apellido"
                            name="apellido"
                            value={hijo.apellido}
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Escuela / Colegio"
                            name="escuela"
                            value={hijo.escuela}
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Edad"
                            name="edad"
                            value={hijo.edad}
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        </Grid>
                      </Grid>

                      {/* BENEFICIOS */}
                      <Typography fontWeight="bold" mt={2}>
                        Beneficios solicitados:
                      </Typography>

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={hijo.clases}
                            name="clases"
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        }
                        label="Clases de apoyo"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={hijo.utiles}
                            name="utiles"
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        }
                        label="Útiles escolares"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={hijo.notebook}
                            name="notebook"
                            onChange={(e) => handleHijoChange(i, e)}
                          />
                        }
                        label="Notebook"
                      />
                    </Paper>
                  ))}

                  {/* BOTÓN AGREGAR HIJO */}
                  <Button
                    variant="contained"
                    onClick={agregarHijo}
                    sx={{ mb: 4, color: "#FFFFFF" }}
                  >
                    Agregar hijo/a
                  </Button>

                  {/* DECLARACIÓN JURADA */}
                  <Box mb={3}>
                    <FormControlLabel
                      control={
                        <Checkbox checked={ddjj} onChange={(e) => setDdjj(e.target.checked)} />
                      }
                      label="Este formulario tiene carácter de declaración jurada"
                    />
                  </Box>

                  {/* BOTÓN ENVIAR */}
                  <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    disabled={!ddjj}
                    onClick={handleSubmit}
                  >
                    Enviar Solicitud
                  </Button>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                lg={3}
                sx={{
                  paddingTop: "2rem",
                }}
              >
                <BackgroundBlogCard
                  image={
                    "https://www.mundiario.com/media/mundiario/images/2019/01/30/2019013017451762854.jpg"
                  }
                  title="Que este año no te pase"
                  description="Solicita la ayuda escolar para el ciclo 2026 desde este formulario de forma rápida y sencilla."
                  action={{
                    type: "internal",
                    route: "/afiliate",
                    label:
                      "Beneficios solo para efiliados, sino aún no estas afiliado, puedes afiliarte, es sencillo",
                  }}
                />
              </Grid>
            </Container>
          </MKBox>
        </Card>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
